import { configureStore, createSlice } from "@reduxjs/toolkit";


const storeSlice = createSlice({
  name: "store",
  initialState: {
    isLoading: false,
    loadingMessage: null,
    currentCustomer: null,
    siteConfig: {
      version: 0
    },
    procedures: [],
    departments: [],
    procedureStates: [],
    proceduresLoaded: false,
  },
  reducers: {
    setStoreItems: (state, action) => {
      Object.keys(action.payload).forEach((key) => {
        state[key] = action.payload[key];
      });
    },
  },
});

const blogSlice = createSlice({
    name: "blog",
    initialState: {
        posts: [],
        blogConfig: {},
    },
    reducers: {
        setBlogItems: (state, action) => {
            Object.keys(action.payload).forEach((key) => {
                state[key] = action.payload[key];
            });
        },
    },
}); 

export const store = configureStore({
  reducer: {
    store: storeSlice.reducer,
    blog: blogSlice.reducer,
  },
});
export const { actions } = storeSlice;

export const setStoreItems = (data) => async(dispatch) => {
    dispatch(actions.setStoreItems(data));
};
export const { setBlogItems } = blogSlice.actions;